import { useMemo } from 'react';
import { sanitizeHtml } from 'src/lib/sanitize';

interface SanitizedHtmlProps {
  html: string;
  className?: string;
  as?: 'div' | 'span' | 'p';
}

/** Render HTML after sanitising it; callers pass raw, untrusted HTML. */
export default function SanitizedHtml({ html, className, as: Tag = 'div' }: SanitizedHtmlProps) {
  const safeHtml = useMemo(() => sanitizeHtml(html), [html]);

  return (
    <Tag
      className={className}
      // eslint-disable-next-line @eslint-react/dom-no-dangerously-set-innerhtml -- input is sanitised by sanitizeHtml above
      dangerouslySetInnerHTML={{ __html: safeHtml }}
    />
  );
}
